export default "__VITE_ASSET__BfOgsraf__"